/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import getFieldSettings from '@/app/utils/getFieldSettings.ts';
/**
 * alo 2
 * @param name field name
 * @returns template string
 */
const transformRegexValue = (name: string): string => {
  return '{{(\\s*?)' + name + '(\\s*?)}}';
};

/**
 * Trả về dạng string của setting
 * @param fields fields control setting
 * @param templateTmp template html string
 * @returns template string
 */
export default (fields: any, templateTmp: string): string => {
  const mapFields = getFieldSettings(fields);
  for (const key in mapFields) {
    // eslint-disable-next-line no-prototype-builtins
    if (Object(mapFields).hasOwnProperty(key) && key) {
      const field = Object(mapFields)[key];
      const name = field.name as string;
      const value = field.default_value;

      // nice regex
      const regex = transformRegexValue(name);
      const match = templateTmp.match(regex);
      if (match?.length) {
        const matched = match[0];
        const matchedString = new RegExp(matched, 'g');
        templateTmp = templateTmp.replace(matchedString, value);
      }
    }
  }
  return templateTmp;
};
